export default __webpack_public_path__ + "static/media/N_sound.38b8728a.mp3";